export enum TemplateEnum {
  pikachu = 'pikachu',
  zetybanking = 'zetybanking',
  wallStreet = 'wallStreet',
  zetymanagement = 'zetymanagement',
  zetydataanalyst = 'zetydataanalyst',
}

export type Template = keyof typeof TemplateEnum;
